import { Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router";
import { useProyecto } from "../../data/ProyectoContext";
import { useJobContext } from "../../hooks/Jobs";
import { useAuthContext } from "../../hooks/Auth";

import LoadingScreenABPBeta from "../../components/Loading/LoadingScreenABPBeta";

const LoadingPageABPBeta = () => {

  

  const loadingMessages = [
  "Excelente la idea que has elegido. En este momento estoy procesando tu solicitud para generar propuestas de proyecto que puedas trabajar con tus estudiantes.",
  "A partir de tu petición, diseño la estructura pedagógica de la propuesta: una problemática desafiante, una pregunta guía y posibles productos finales.",
  "Además, tengo en cuenta tu contexto para formular problemáticas relevantes que den sentido al proyecto y conecten con la realidad de tus estudiantes.",
  "Ahora mismo elaboro una pregunta guía que sirva como eje articulador del proyecto y promueva el pensamiento crítico y la resolución de problemas.",
  "Paralelamente, ajusto los productos finales para que ofrezcan a los estudiantes un claro sentido de logro y propósito en su trabajo.",
  "También incorporo información sobre beneficiarios, storytelling, conceptos clave y aprendizajes esperados para enriquecer la propuesta.",
  "Recuerda que yo te propongo ideas, pero tú tienes la última palabra. Podrás editar haciendo clic en el lápiz y tomaré en cuenta tus ajustes para la siguiente etapa.",
  "Con todos estos elementos, organizo una experiencia de aprendizaje coherente, auténtica y significativa.",
  "Antes de finalizar, reviso que la propuesta esté alineada con los objetivos de aprendizaje y el contexto de tus estudiantes.",
  "Ya casi terminamos. ¡Juntos vamos a construir una propuesta de aprendizaje basado en proyectos ajustada a tu contexto!",
];


  const [messageIndex, setMessageIndex] = useState(0);
  const loadingText = loadingMessages[messageIndex];

  const { proyecto } = useProyecto();
  const {
    isCompleted,
    isFailed,
    etapa,
    propuestaUsuario,
    handleStartJobABPBeta,
    msgLoading,
    msgLoadingUnidad,
    userId,
  } = useJobContext();
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const didNavigateRef = useRef(false);

  const isABP = useMemo(() => {
    return proyecto?.tipo_estructura === "Aprendizaje basado en proyectos";
  }, [proyecto?.tipo_estructura]);

  const handleResendProyect = () => {
    handleStartJobABPBeta(propuestaUsuario, etapa, "crear_proyecto");
  };
 

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => {
        const next = prev + 1;
       
        if (next >= loadingMessages.length) return loadingMessages.length - 1;
        return next;
      });
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isCompleted && !isFailed && !didNavigateRef.current) {
      didNavigateRef.current = true;

      const target = `/asistente/${isABP ? "abpbeta" : "unidadtematica"}`;
      navigate(target, { replace: true });
    }

  
    if (isFailed) {
      didNavigateRef.current = false;
    }
  }, [isCompleted, isFailed, isABP, navigate]);

  const loadingMessage = isABP ? msgLoading : msgLoadingUnidad;

  if (!isCompleted && !isFailed) {
    return (
      <LoadingScreenABPBeta
        footerText={loadingText}
      
      />
    );
  }

 
  if (isFailed) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "5%", overflow: "hidden"}}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            height="100vh"
          >
            <Typography variant="h6" align="center" mt={2}>
              Lo siento, hubo un problema de comunicación con el servidor de
              UmmIA. Por favor intentémoslo de nuevo.
              <br />
              <br />
              <Button
                variant="contained"
                onClick={handleResendProyect}
                data-amplify-analytics-on="click"
                data-amplify-analytics-name={`click-on-loading-failed-reenviar`}
                data-amplify-analytics-attrs={`onClick:handleResendProyect, userId:${userId}`}
              >
                Reenviar propuesta
              </Button>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    );
  }

  return null;
};

export default LoadingPageABPBeta;
